import React, { useRef, useState } from "react";
import PhoneIcon from "../Icon/PhoneIcon";
import MailIcon from "../Icon/MailIcon";
import LocationIcon from "../Icon/LocationIcon";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_mc0wa4r",
        "template_0lefhis",
        form.current,
        "iNefYiqaHRjY6TfXw"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast('message sent');
        },
        (error) => {
          toast.error(error.text);
        }
      );
  };

  

  return (
    <div className="bg-accent pl-4 w-full py-5">
      <div className="pt-20 mb-8">
        <h2 className="text-4xl font-bold uppercase text-white border-l-4 border-primary pl-3">
          Contacts Me
        </h2>
        <span class="text-6xl font-semibold hover:font-bold uppercase text-base-100">
          Contacts me
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
        <div>
          <h2 className="text-2xl text-white">Get In Touch</h2>
          <form ref={form} onSubmit={sendEmail} action="">
            <div class="card-body">
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Enter Your Name</span>
                </label>
                <input type="text" name="name" class="input input-bordered" />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Enter Your Email</span>
                </label>
                <input type="email" name="email" class="input input-bordered" />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Enter Your Subject</span>
                </label>
                <input
                  type="text"
                  name="subject"
                  class="input input-bordered"
                />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Message</span>
                </label>
                <textarea
                  name="message"
                  class="
                            bg-base-100
                            block
                            w-full
                            mt-1
                            border-gray-300
                            rounded-md
                            shadow-sm
                            focus:border-indigo-300
                            focus:ring
                            focus:ring-indigo-200
                            focus:ring-opacity-50
                        "
                  rows="5"
                ></textarea>
              </div>
              <div class="form-control mt-6">
                <button class="btn btn-primary ">Send Mail</button>
              </div>
            </div>
            <ToastContainer />
          </form>
        </div>
        <div>
          <div className="flex justify-start bg-neutral p-5">
            <div>
              <PhoneIcon></PhoneIcon>
            </div>
            <div className="m-5">
              <h2 className="text-2xl">Phone</h2>
              <h4>+8801306557392</h4>
            </div>
          </div>
          <div className="flex justify-start bg-neutral p-5 mt-10">
            <div>
              <MailIcon></MailIcon>
            </div>
            <div className="m-5">
              <h2 className="text-2xl">Email</h2>
              <h4>saiful607571@gmail.com</h4>
            </div>
          </div>
          <div className="flex justify-start bg-neutral p-5 mt-10">
            <div>
              <LocationIcon></LocationIcon>
            </div>
            <div className="m-5">
              <h2 className="text-2xl">Address</h2>
              <h4>Mirpur,Dhaka-1236, Bangladesh</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
